const ViewSummary = (params) => {
    var sourval = params.data.consigner_code;
    var sourcename = params.data.sourcename;
    var destination = params.data.consignee_code;
    const link = `/deviationanalysisdata?source=${sourval}&destination=${destination}&period_type=${params.selected_period_type}&truck_type=${params.selected_truck_type}`
    return (
        <a href={link} target="_blank" className="btn btn-warning" style={{ padding: "2px", width: "7em;" }} rel="noopener">View Summary</a>
    );
}
export default ViewSummary